<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-3.3 3.29 4.71 4.7 4.71-4.7-3.3-3.29C13 2.19 12.5 2 12 2M5.88 7.29l-3.29 3.3c-.79.78-.79 2.04 0 2.82l3.29 3.3 4.7-4.71-4.7-4.71m12.24 0L13.42 12l4.7 4.71 3.29-3.3c.79-.78.79-2.04 0-2.82l-3.29-3.3M12 13.42l-4.71 4.7 3.3 3.29c.78.79 2.04.79 2.82 0l3.3-3.29-4.71-4.7z"/>
    </svg>
</template>

<script>
export default {
    name: 'RhombusSplitIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
